export default function ContactHero() {
  return (
    <section className="relative h-[400px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e46205edfd837101c03d28a6208946ba.jpg"
          alt="Contact KaliKare"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>
      
      <div className="relative z-10 text-center px-4">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
          Get In Touch
        </h1>
        <p className="text-xl text-white/90 max-w-2xl mx-auto">
          We're here to answer your questions and help you get started with compassionate care
        </p>
      </div>
    </section>
  );
}
